export enum ExceptionWeights {
  WARNING = 1,
  ERROR = 2
}
